import api from '../api';

export const getPendingFinancials = async (companyId) => {
  try {
    if (!companyId || !['string', 'number'].includes(typeof companyId)) {
      return null;
    }
    const { data } = await api.get(
      `empresa/pendenciasFinanceiras/${companyId}`,
    );
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
};
